
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.733 14.819a.75.75 0 00-1.257-.345l-4.648 4.648-4.242-.707-.707-4.242 4.647-4.648a.751.751 0 00-.354-1.26 8.995 8.995 0 00-8.536 2.37c-2.477 2.478-3.16 6.07-2.128 9.2L9.171 33.173a4 4 0 005.657 5.657l13.325-13.326c3.133 1.044 6.717.355 9.21-2.139a8.996 8.996 0 002.37-8.545zM12 37.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","fill":"#535353"}})])
          )
        }
      }
    